export const types = {
  HIDE_CHAT: 'HIDE_CHAT',
  HIDE_SUPPORT_PANEL: 'HIDE_SUPPORT_PANEL',
  SHOW_CHAT: 'SHOW_CHAT',
  SHOW_SUPPORT_PANEL: 'SHOW_SUPPORT_PANEL',
}
